import {
  Box,
  Button,
  Chip,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import moment from "moment";
import { useState } from "react";

const PAGE_SIZE = 5;

type PricePeriod = {
  type: "simple" | "minim";
  field: string;
  value: number | null;
  old_value: number | null;
  valid_from: string;
  valid_until: string | null;
  changed_by: string | null;
};

type PricePeriodsHistoryProps = {
  periods: PricePeriod[];
};

const FIELD_LABELS: Record<string, string> = {
  pret_site_vanzare: "Preț vânzare",
  pret_minim_vanzare: "Preț promotional",
  pret_vanzare_euro: "Preț vânzare",
  pret_vechi_vanzare: "Preț Preț vânzare",
  buget: "Buget",
};

const TYPE_LABELS: Record<string, string> = {
  simple: Vocabulary.siteSalePrice,
  minim: Vocabulary.minimalSalePriceHistory,
};

function formatPrice(value: number | null): string {
  if (value === null || value === undefined) return "—";
  return Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function getPeriodLabel(period: PricePeriod): string {
  const from = moment(period.valid_from).format("DD-MM-YYYY");
  const until = period.valid_until
    ? moment(period.valid_until).format("DD-MM-YYYY")
    : Vocabulary.activePricePeriod;
  return `${from}  →  ${until}`;
}

function getFieldLabel(period: PricePeriod): string {
  return FIELD_LABELS[period.field] ?? TYPE_LABELS[period.type] ?? period.field;
}

export default function PricePeriodsHistory({
  periods,
}: PricePeriodsHistoryProps) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  if (!periods.length) return null;

  return (
    <>
    <Stepper orientation="vertical" style={{ padding: 10 }}>
      {periods.slice(0, visibleCount).map((period, index) => (
        <Step key={index} active={true}>
          <StepLabel
            StepIconComponent={() => (
              <Chip
                style={{
                  backgroundColor:
                    period.valid_until === null ? "#e8f5e9" : "#f5f5f5",
                  color: period.valid_until === null ? "#2e7d32" : "#555",
                  fontSize: "0.85rem",
                  fontWeight: period.valid_until === null ? 700 : 400,
                  borderRadius: "5px",
                  border: period.valid_until === null
                    ? "1px solid #a5d6a7"
                    : "1px solid #ddd",
                }}
                label={getPeriodLabel(period)}
              />
            )}
          />
          <StepContent>
            <Box
              style={{
                borderRadius: "7px",
                backgroundColor: "#fff",
                boxShadow:
                  "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
                marginTop: "8px",
                padding: "12px 16px",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              <Typography
                style={{ fontSize: "0.75rem", color: "#888", marginBottom: 4 }}
              >
                {getFieldLabel(period)}
              </Typography>
              <Typography style={{ fontSize: "1.1rem", fontWeight: 600 }}>
                {period.old_value !== null ? (
                  <>
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#999",
                        marginRight: 8,
                      }}
                    >
                      {formatPrice(period.old_value)} €
                    </span>
                    {"→ "}
                    <span style={{ color: "#1976d2" }}>
                      {formatPrice(period.value)} €
                    </span>
                  </>
                ) : (
                  <span style={{ color: "#1976d2" }}>
                    {formatPrice(period.value)} €
                  </span>
                )}
              </Typography>
              <Typography
                style={{
                  fontSize: "0.75rem",
                  fontStyle: "italic",
                  color: "#666",
                  marginTop: 6,
                }}
              >
                {period.changed_by
                  ? Vocabulary.updatedBy + period.changed_by
                  : Vocabulary.systemAssociated}
              </Typography>
            </Box>
          </StepContent>
        </Step>
      ))}
    </Stepper>
    {periods.length > visibleCount && (
      <Button
        onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
        style={{ display: "block", margin: "0 auto 16px" }}
      >
        {Vocabulary.loadMore}
      </Button>
    )}
    </>
  );
}
